import React from 'react';

export default function(htmlText, classString) {
	return (
		<span
			className={classString}
			dangerouslySetInnerHTML={{ __html: htmlText }}
		/>
	)
}
